import { createContext, useEffect, useState } from 'react'

import { InformationAPI } from '@builddocs/data-management-rest'
import { useQuery } from 'react-query'
import { useMatch } from 'react-router'

export const FeatureFlagContext = createContext({
  BUILDDOCS1941: true,
  ErrorTest: false,
})

export function useFeatureFlags() {
  const match = useMatch('projects/:projectId/*')

  return useQuery<{
    adsIsEnabled: 'true' | 'false'
    mchdEmployeeSignProtectionIsEnabled: 'true' | 'false'
  }>({
    queryFn: () =>
      InformationAPI.get('/ft', {
        params: { projectId: match?.params.projectId },
      }).then(res => res.data),
    queryKey: ['feature-flags', match?.params.projectId],
  })
}

/**
 * @deprecated компонент вызывает лишние ререндеры
 */
export function FeatureFlagProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [featureFlags, setFeatureFlags] = useState({
    BUILDDOCS1941: true,
    ErrorTest: false,
  })

  useEffect(() => {
    // @ts-expect-error добавляем
    window.toggleBuilddocs1941 = () => {
      setFeatureFlags(val => ({
        ...val,
        BUILDDOCS1941: !val.BUILDDOCS1941,
      }))
    }

    // @ts-expect-error добавляем
    window.toggleErrorTest = () => {
      setFeatureFlags(val => ({
        ...val,
        ErrorTest: !val.ErrorTest,
      }))
    }

    return () => {
      // @ts-expect-error удаляем
      window.toggleBuilddocs1941 = undefined
      // @ts-expect-error удаляем
      window.toggleErrorTest = undefined
    }
  }, [])

  return (
    <FeatureFlagContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagContext.Provider>
  )
}
